import { ReactElement } from 'react';

import { PlanFeaturesTypes } from '~globals/types/enums';
import AccessFeature from '~components/AccessFeature';
import Subscription from '~components/Subscription';

import { useDashboardVariantV2CarrierContext } from '../../../Context';
import DashboardVariantV2CarrierContentInWarehouseTabProvider from './Context';

import {
  DashboardVariantV2CarrierContentTabContainer,
  DashboardVariantV2CarrierContentWrapper,
} from '../../styles';

import {
  DashboardVariantV2CarrierContentInWarehouseTabActions,
  DashboardVariantV2CarrierContentInWarehouseTabCurrenFilters,
  DashboardVariantV2CarrierContentInWarehouseTabDataTable,
  DashboardVariantV2CarrierContentInWarehouseTabMap,
} from './Components';
import DashboardVariantV2CarrierZoneSaturation from '../../../ZoneSaturation';

const DashboardVariantV2CarrierContentInWarehouseTab = (): ReactElement => {
  const {
    data: {
      zoneSaturation: {
        data: { zones },
      },
    },
  } = useDashboardVariantV2CarrierContext();

  return (
    <DashboardVariantV2CarrierContentInWarehouseTabProvider>
      <DashboardVariantV2CarrierContentTabContainer>
        <DashboardVariantV2CarrierContentInWarehouseTabActions />

        {zones.length > 0 && (
          <AccessFeature.Hidden
            validFeature={PlanFeaturesTypes.MgmZones}
            type="notAccess"
          >
            <DashboardVariantV2CarrierZoneSaturation />
          </AccessFeature.Hidden>
        )}

        <DashboardVariantV2CarrierContentInWarehouseTabCurrenFilters />

        <div>
          <Subscription.AvailableRoutesState.Alert
            withButtons
            withCloseAction
            sx={(currentTheme) => ({
              padding: currentTheme.spacing(0, 2, 2, 2),
            })}
          />
        </div>

        <DashboardVariantV2CarrierContentWrapper>
          <DashboardVariantV2CarrierContentInWarehouseTabDataTable />

          <DashboardVariantV2CarrierContentInWarehouseTabMap />
        </DashboardVariantV2CarrierContentWrapper>
      </DashboardVariantV2CarrierContentTabContainer>
    </DashboardVariantV2CarrierContentInWarehouseTabProvider>
  );
};

export default DashboardVariantV2CarrierContentInWarehouseTab;
